import { Button } from '@insify/design-system/components';
import { textMd } from '@insify/design-system/typography';
import clsx from 'clsx';

import * as styles from './NoResult.module.css';

type Props = {
  noResultHeader: string;
  noResultCTA?: string;
  noResultPhone?: string;
};

export const NoResult = ({ noResultHeader, noResultCTA, noResultPhone }: Props): JSX.Element => {
  return (
    <div className={styles.wrapper}>
      <p className={clsx(textMd, styles.header)}>{noResultHeader}</p>
      {noResultPhone && (
        <Button
          kind='secondary'
          trackingId='contactViaWhatsapp'
          href={`tel:${noResultPhone}`}
          className={styles.contactButton}
        >
          {noResultCTA}
        </Button>
      )}
    </div>
  );
};
